import { render, staticRenderFns } from "./Robot.vue?vue&type=template&id=665fa4ca&scoped=true&"
import script from "./Robot.vue?vue&type=script&lang=ts&"
export * from "./Robot.vue?vue&type=script&lang=ts&"
import style0 from "./Robot.vue?vue&type=style&index=0&id=665fa4ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665fa4ca",
  null
  
)

export default component.exports